module.exports = "<h1 mat-dialog-title>Confirm</h1>\n<mat-dialog-content>\n  <h2>{{data.message}}</h2>\n  <h3>{{data.submessage}}</h3>\n</mat-dialog-content>\n<mat-dialog-actions  align=\"end\">\n  <button mat-raised-button (click)=\"close()\" mat-dialog-close><mat-icon>cancel</mat-icon></button>\n  <button mat-raised-button color=\"warn\" (click)=\"delete()\"><mat-icon>delete_forever</mat-icon></button>\n</mat-dialog-actions >\n"


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/delete-confirm-dialog/delete-confirm-dialog.component.html
// module id = ../../../../../src/app/delete-confirm-dialog/delete-confirm-dialog.component.html
// module chunks = main